//import {InputCompletedContext} from '../objects/Context/input_completed_context';
import React from 'react';
import TestActivities from '../components/special/test_activities';
import withRouterCompat from "../objects/CommonUse/with_router_compat";


class SpecialActivity extends React.Component {
    constructor(props) {
        super(props);
  

     this.state = {
        inputArr: [
            {
                completed: false,
                selected: false
            },
            {
                completed: false,
                selected: false
            },
          
        ],
        gameData: null,
        gameDataSw: false,
        doneLoading: false,
        loading: true,
        data: null,
        fancyDragNDrop: true,
        openMapAnimation: true,
        gameInfo: {
            loading: true,
            gameData: {},
            cardList: [],
            currentCard: {},
            eventConditions: [],
            pictureInfo: "",
            savingsInfo: "",
            creditCardInfo: {},
            friendInfo: {},
            displayFriendInfo: {},
            activityTracker: {},
            creditCardLoaded: false,
            nextEventNbr: "",
            displayType: "none",   
        },
        specialInfo: {
            loading: true,
            loadingConditions: true,
            gameData: {},
            conditionsData: [],
            currentCard: "",
            cardList: [],
            cardIdx: 0,
            cardResponses: []
        }
    };

    switch(props.selected) {
        case "specialProcessMain":
            this.inputSelected(0);
            break;
        case "testActivities":
            this.inputSelected(2);
            break;
        default:
            break;
     }
}

    onNavigate = (path) => {
        const { navigate, location } = this.props;

        const targetPath = `/${path}`;
        // Only navigate if we aren’t already there
        if (location.pathname !== targetPath) {
            navigate(`/${path}`, { replace: true });
        }
    };

    render(){
       
    return <>
        <div className="container m-0 p-0">
                <div className="row w-100 mx-0">
                   
                    <TestActivities
                         onNavigate={(pathname) => this.onNavigate(pathname)}
                        /> 
                                        
                </div>
        {/*
                 {process.env.NODE_ENV === 'development' && (
                        <div className="breakpoint-indicator" />
                        )}
        */}
        </div>   
                  
    </>
}

componentDidMount(){
    this._isMounted = true;
    this.inputSelected(0);
    let el = document.querySelector('#container');
while (el) {
  if (el.scrollHeight > el.clientHeight) {
    console.log('OVERFLOW FOUND:', el, 
      '\nClass:', el.className, 
      '\nID:', el.id,
      '\nscrollHeight:', el.scrollHeight, 
      '\nclientHeight:', el.clientHeight);
  }
  el = el.firstElementChild;
}

}
        
inputSelected = (inputID) => {
    let inputArr = this.state.inputArr;
    for (const input of inputArr) {
        input.selected = false;
    }
    inputArr[inputID].selected = true;
    if (this._isMounted === true){
        this.setState({inputArr: inputArr}); 
    } 
       
};

handleClick = index => {
    this.inputSelected(index);
    this.index = index;
}

getGameInfo()
{
    return this.state.gameInfo;
}

setGameInfo(value, propertyName = null)
{
    if (propertyName)
    {
        let gameInfo = this.state.gameInfo;
        gameInfo[propertyName] = value;
        this.setState({gameInfo: gameInfo});
    }
    else{ this.setState({gameInfo: value});
    }
         
}

getSpecialInfo()
{
    return this.state.specialInfo;
}

setSpecialInfo(value, propertyName = null)
{
    if (propertyName)
    {
        let specialInfo = this.state.specialInfo;
        specialInfo[propertyName] = value;
        this.setState({specialInfo: specialInfo});
    }
    else{ this.setState({specialInfo: value});
    }
         
}

}

export default (withRouterCompat(SpecialActivity));